import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import { Box, makeStyles, Typography } from "@material-ui/core";
import { useField } from "react-final-form";

const useStyles = makeStyles((theme) => ({
  selected: { backgroundColor: theme.orange + "!important" },
  container: {
    display: "grid",
    gridTemplateColumns: "150px auto",
    gridGap: 0,
    marginTop: 15,
    marginBottom: 15,
    // marginLeft: 20,
  },
  textStyle: { fontSize: 16 },
  toggleButton: {
    width: 100,
    height: 40,
  },
}));
const SkipStockInput = ({ disabled }) => {
  const classes = useStyles();
  let {
    input: { onChange, value },
    //meta: { touched, error },
  } = useField("skip_stock");

  const handleToggle = (_, v) => {
    onChange(v);
  };
  return (
    <Box className={classes.container}>
      <Typography className={classes.textStyle}>Skip stock</Typography>
      <ToggleButtonGroup exclusive value={value} onChange={handleToggle}>
        <ToggleButton
          className={classes.toggleButton}
          classes={{ selected: classes.selected }}
          value={true}
          disabled={disabled}
        >
          Yes
        </ToggleButton>
        <ToggleButton
          className={classes.toggleButton}
          classes={{ selected: classes.selected }}
          value={false}
          disabled={disabled}
        >
          No
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

export default SkipStockInput;
